import React from 'react';
import ExpenseItem from './ExpenseItem';
import './ExpensesList.css';
const ExpensesList=props=>{

    if(props.items.length===0)   //agar koi expense nhi mila to if statement ye print kardega
    {
           return <h2 className='expenses-list__fallback'>No Expenses Found!</h2>
    }
   
//agar koi expense mile array me to else case niche vali return statement chal jaegi..aur items display ho jaege
return <ul className="expenses-list"> 
{
props.items.map((expenses)=>
(
  <ExpenseItem
   key={expenses.id} 
   title={expenses.title} 
   amount={expenses.amount}
    date={expenses.date}/>
))}


</ul>

};
export default ExpensesList;